import React, { useEffect, useState } from 'react';

import { AccordionDetails, Grid } from '@mui/material';
import LeaveQuotaCardComponent from '../LeaveQuotaCardComponent';
import { getLeaveTypeForUser } from '../../../../services/UserService';
import { useDispatch } from 'react-redux';
import { SHOW_NOTIFICATION } from '../../../../constants';
import { isCasualLeaveRecord } from '../../../../utils/casualLeaveUtils';

const LeavesQuotaAccordian = (props) => {
  const { data, leaveGroupId, leaveGroupHydrationFailed } = props;
  const dispatch = useDispatch();
  const [labels, setLabels] = useState([]);
  const date = new Date();
  const hasLeaveGroup =
    leaveGroupId != null && leaveGroupId !== '' && leaveGroupId !== undefined;
  // Hydration failure must not look like "No Group" (would show annual Casual controls).
  const treatAsGroupedForCasual =
    hasLeaveGroup || leaveGroupHydrationFailed === true;

  const dipatchNotification = (typ, msg) => {
    dispatch({
      type: SHOW_NOTIFICATION,
      data: {
        open: true,
        type: typ,
        message: msg,
      },
    });
  };

  const getLeaveLabel = (id) => {
    for (let i = 0; i < labels.length; i++) {
      const label = labels[i];
      if (label.id === id) return label;
    }
  };

  const isCasualLeaveLabel = (label) => isCasualLeaveRecord(label);

  const getLeaveType = () => {
    let leaveList = [];
    if (
      data !== undefined &&
      data !== null &&
      labels !== undefined &&
      labels.length !== 0 &&
      labels !== null
    ) {
      data
        .filter((leave) => {
          const label = getLeaveLabel(leave.leaveId);
          // Hide annual Casual Leave quota editing when employee has a Leave Group
          // or when Leave Group lookup failed (fail closed for UI).
          if (treatAsGroupedForCasual && isCasualLeaveLabel(label)) {
            return false;
          }
          return true;
        })
        .map((leave) => {
          leaveList.push({
            label: getLeaveLabel(leave.leaveId),
            ...leave,
          });
        });
    }
    return leaveList;
  };

  const getLeaveTypesLabels = async () => {
    const response = await getLeaveTypeForUser(date.getFullYear());
    let leavesLabel = [];
    if (response.isError === false) {
      response.data.map((data) => {
        leavesLabel.push({
          id: data.id,
          label: data.leaveName,
          color: data.color,
        });
      });
      setLabels(leavesLabel);
    }
    if (response.status !== 200) {
      dipatchNotification(response.type, response.message);
    }
  };

  useEffect(() => {
    getLeaveTypesLabels();
  }, [data]);

  useEffect(() => {
    if (leaveGroupHydrationFailed === true) {
      dipatchNotification(
        'warning',
        'Unable to load Leave Group assignment; Casual Leave annual quota controls are hidden until lookup succeeds.',
      );
    }
  }, [leaveGroupHydrationFailed]);

  return (
    <AccordionDetails>
      <Grid container justify="center" alignItems="center">
        <Grid item xs={12}>
          {getLeaveType().map((val) => (
            <LeaveQuotaCardComponent key={val.id} leave={val} />
          ))}
        </Grid>
      </Grid>
    </AccordionDetails>
  );
};

export default LeavesQuotaAccordian;
